var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.overviews")) +
                " > " +
                _vm._s(_vm.$t("sidebar.skuslevel")) +
                "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "row", staticStyle: { "margin-bottom": "12px" } },
            [
              _c("div", { staticClass: "col-lg-4 ml-auto" }, [
                _c(
                  "label",
                  { staticClass: "d-flex d-flex align-items-center" },
                  [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.search")) +
                          ":\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("BaseInput", {
                      attrs: {
                        placeholder: _vm.$t("placeholder.searchstock"),
                        type: "text",
                        clear: ""
                      },
                      on: {
                        onEnter: _vm.handleSearchEnter,
                        onClear: _vm.handleSearchClear
                      },
                      model: {
                        value: _vm.query.q,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "q", $$v)
                        },
                        expression: "query.q"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("BaseTableSkuLevel", {
            attrs: {
              headColumns: _vm.headColumns,
              rows: _vm.data,
              pagination: _vm.pagination,
              empty: _vm.empty,
              query: _vm.query
            },
            on: {
              onSortChange: _vm.handleSortChange,
              onPageChange: _vm.handlePageChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92143c46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92143c46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/overview/SkuLevel.vue
// module id = null
// module chunks = 